<template>
  <div class="step-four tutorial">
    <h2>Update the live site when you PR from <i>development</i> to <i>master</i></h2>
    <h4>Pull requests</h4>
    <h4>Adding a pipeline</h4>
    <h4>Setting up for a static page</h4>
    <h4>Testing</h4>
  </div>
</template>
